<template>
  <div class="warp">
    <el-form
      ref="searchForm"
      :model="searchForm"
      :rules="searchFormRules"
      :inline="true"
      label-position="right"
      label-width="70px"
      class="searchForm"
    >
      <el-form-item label="年级：" prop="subjectId">
        <el-select
          v-model="searchForm.subjectId"
          name="subjectId"
          size="medium"
          class="handle-form-input"
        >
          <el-option
            v-for="item in searchFormGradesList"
            :key="item.dirId"
            :label="item.dirName"
            :value="item.dirId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="学科：" prop="gradeId">
        <el-select
          v-model="searchForm.gradeId"
          name="gradeId"
          size="medium"
          class="handle-form-input"
        >
          <el-option
            v-for="item in searchFormSubjectsList"
            :key="item.gradeId"
            :label="item.gradeName"
            :value="item.gradeId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="类型：" prop="gradeId">
        <el-select
          v-model="searchForm.gradeId"
          name="gradeId"
          size="medium"
          class="handle-form-input"
        >
          <el-option
            v-for="item in searchFormTypeList"
            :key="item.gradeId"
            :label="item.gradeName"
            :value="item.gradeId"
          />
        </el-select>
      </el-form-item>
      <el-form-item style="margin-left:0;">
        <el-input
          v-model="searchForm.type"
          suffix-icon="el-icon-search"
          :maxlength="30"
          name="type"
          placeholder="输入关键字查找应用"
          class="form-input"
          clearable
        />
      </el-form-item>
      <el-form-item style="margin-left:0;">
        <el-button type="primary" size="medium" icon="el-icon-search">
          查找
        </el-button>
        <el-button size="medium">
          我的应用
        </el-button>
        <el-button size="medium">
          应用定制
        </el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeNameTabs" @tab-click="handleTabLoad">
      <el-tab-pane label="全部应用" name="one">
        <TabList :props-obj="propsObj" />
      </el-tab-pane>
      <el-tab-pane label="联机应用" name="two">
        <TabList />
      </el-tab-pane>
      <el-tab-pane label="教师应用" name="three">
        <TabList />
      </el-tab-pane>
      <el-tab-pane label="学生应用" name="four">
        <TabList />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import TabList from './tabList';
export default {
  name: 'InteractiveTeaApp',
  components: {
    TabList
  },
  props: {
    propsId: {
      default: String,
      type: String
    }
  },
  data: () => {
    return {
      activeNameTabs: 'one',
      searchForm: {},
      searchFormRules: {},
      propsObj: {
        link: 'moduleDetail'
      }
    };
  },
  computed: {
    searchFormGradesList() {
      return [];
    },
    searchFormSubjectsList() {
      return [];
    },
    searchFormTypeList() {
      return [];
    }
  },
  watch: {
    propsId: {
      handler: function(val) {
        this.propsObj.propsId = val;
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    handleTabLoad() {

    }
  }
};
</script>
